import React, { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import router from "./router/router";
import { useTranslation } from "react-i18next";
import { setFilteredCountries } from "./Header/store/headerSlice";
import { useAppDispatch } from "@features/store/store";
import { GetLanguages } from "@pages/LanguageTranslations/Languages/store/thunk";
import toast from "react-hot-toast";
import { useDefaultLanguage } from "@pages/LanguageTranslations/Languages/store/selector";

function App() {
    const { i18n } = useTranslation();
    const savedLanguage = localStorage.getItem("languages") || "en";
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const defaultLanguage = useDefaultLanguage() || "";

    useEffect(() => {
        if (!defaultLanguage) return;
        dispatch(setFilteredCountries({ defaultLanguage }));
    }, [defaultLanguage]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                await dispatch(GetLanguages()).unwrap();
            } catch (err) {
                toast.error(t(`messages.${err}`));
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        i18n.changeLanguage(savedLanguage);
    }, [i18n]);

    return <RouterProvider router={router} />;
}

export default App;
